// import { Navigate } from 'react-router-dom';
import { APP_ROLES_NAMES } from 'constants/app-roles';
import SanityStudio from 'features/sanity/routes/SanityStudio';

// EndUser
import { ProfileRoute } from 'features/endUser';
import { EndUsersRoute } from 'features/endUser/routes/endUsers';

// CompanyOwner
import { AddCompanyOwnerRoute } from 'features/company-owner/routes/add-company-owner';
import { CompanyOwnersRoute } from 'features/company-owner/routes/company-owners';
import { EditCompanyOwnerRoute } from 'features/company-owner/routes/edit-company-owner';

// Company
import { CompaniesRoute } from 'features/company';
import { AddCompanyRoute } from 'features/company/routes/add-company';
import { EditCompanyRoute } from 'features/company/routes/edit-company';

// Website
import { AddWebsiteRoute } from 'features/website/routes/add-website';
import { EditWebsiteRoute } from 'features/website/routes/edit-website';
import { WebsitesRoute } from 'features/website/routes/websites';

// Terminal
import { AddTerminalRoute } from 'features/terminal/routes/add-terminal';
import { EditTerminalRoute } from 'features/terminal/routes/edit-terminal';
import { TerminalsRoute } from 'features/terminal/routes/terminals';

// Place
import { AddPlaceRoute } from 'features/place/routes/add-place';
import { EditPlaceRoute } from 'features/place/routes/edit-place';
import { PlacesRoute } from 'features/place/routes/places';

// Product
import { AddProductRoute } from 'features/product/routes/add-product';
import { EditProductRoute } from 'features/product/routes/edit-product';
import { ProductsRoute } from 'features/product/routes/products';

// Product Category
import { AddProductCategoryRoute } from 'features/product-category/routes/add-product-category';
import { EditProductCategoryRoute } from 'features/product-category/routes/edit-product-category';
import { ProductCategoriesRoute } from 'features/product-category/routes/product-categories';

// Nested Product
import { AddNestedProductRoute } from 'features/nested-product/routes/add-nested-product';
import { EditNestedProductRoute } from 'features/nested-product/routes/edit-nested-product';
import { NestedProductsRoute } from 'features/nested-product/routes/nested-products';

// Nested Product Category
import { AddNestedProductCategoryRoute } from 'features/nested-product-category/routes/add-nested-product-category';
import { EditNestedProductCategoryRoute } from 'features/nested-product-category/routes/edit-nested-product-category';
import { NestedProductCategoriesRoute } from 'features/nested-product-category/routes/nested-product-categories';

// Orders
import { OrderDetailsRoute } from 'features/orders/routes/order-details';
import { OrdersRoute } from 'features/orders/routes/orders';

// Promotions
import { AddPromotionRoute } from 'features/promotion/routes/add-promotion';
import { EditPromotionRoute } from 'features/promotion/routes/edit-promotion';
import { PromotionsRoute } from 'features/promotion/routes/promotions';

// type Routes
type Routes = {
    path: string;
    element: JSX.Element;
    permissions: string[];
};

export const protectedRoutes: Routes[] = [
    //Profile routes
    {
        path: 'profile',
        element: <ProfileRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    //Sanity routes
    {
        path: 'website/:websiteIdStudio/sanity-studio/*',
        element: <SanityStudio />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },

    //End user routes
    {
        path: 'end-users',
        element: <EndUsersRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    //Company owner routes
    {
        path: 'company-owners',
        element: <CompanyOwnersRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'add/company-owner',
        element: <AddCompanyOwnerRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'company-owner/:id',
        element: <EditCompanyOwnerRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    //Company routes
    {
        path: 'companies',
        element: <CompaniesRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'add/company',
        element: <AddCompanyRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'company/:id',
        element: <EditCompanyRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    //Website routes
    {
        path: 'websites',
        element: <WebsitesRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'website/:websiteIdEdit',
        element: <EditWebsiteRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'add/website',
        element: <AddWebsiteRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    //Terminal routes
    {
        path: 'terminals',
        element: <TerminalsRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'add/terminal',
        element: <AddTerminalRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'terminal/:id',
        element: <EditTerminalRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    //Places routes
    {
        path: 'places',
        element: <PlacesRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'add/place',
        element: <AddPlaceRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'place/:id',
        element: <EditPlaceRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    //Product routes
    {
        path: 'products/:placeId',
        element: <ProductsRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'products/:placeId/add/product',
        element: <AddProductRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'product/:placeId/edit/:productId',
        element: <EditProductRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    //Product categories routes
    {
        path: 'productCategories',
        element: <ProductCategoriesRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'add/productCategory',
        element: <AddProductCategoryRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    {
        path: 'productCategory/:productCategoryId',
        element: <EditProductCategoryRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR],
    },
    //Nested products routes
    {
        path: 'nestedProducts/:placeId',
        element: <NestedProductsRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'nestedProducts/:placeId/add/nestedProduct',
        element: <AddNestedProductRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'nestedProduct/:placeId/edit/:nestedProductId',
        element: <EditNestedProductRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    //Nested product categories routes
    {
        path: 'nestedProductCategories',
        element: <NestedProductCategoriesRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'add/nestedProductCategory',
        element: <AddNestedProductCategoryRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'nestedProductCategory/:nestedProductCategoryId',
        element: <EditNestedProductCategoryRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    //Orders routes
    {
        path: 'orders/:placeId',
        element: <OrdersRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'order/:placeId/:orderId',
        element: <OrderDetailsRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    //Promotions routes
    {
        path: 'promotions/:placeId',
        element: <PromotionsRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'promotions/:placeId/add/promotion',
        element: <AddPromotionRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
    {
        path: 'promotion/:placeId/edit/:promotionId',
        element: <EditPromotionRoute />,
        permissions: [APP_ROLES_NAMES.ADMINISTRATOR, APP_ROLES_NAMES.COMPANY_OWNER],
    },
];
